import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import RightSvg from '../components/icons/RightSvg'
import SectionHeader from '../components/sections/SectionHeader'
import AboutCompanyAU from '../components/sections/AboutCompanyAU'
import VisionAU from '../components/sections/VisionAU'
import Faq from '../components/sections/Faq'
import PagesHeader from '../components/sections/PagesHeader'
import { Helmet } from 'react-helmet'

export class AboutUs extends Component {
    render() {
        return (
            <main className=''>

                <Helmet>
                    {/* Meta Title */}
                    <title>ITnova Haqqımızda - İT, Veb Dizayn, Mobil Tətbiq və SEO Xidmətləri</title>

                    {/* Meta Description */}
                    <meta name="description" content="ITnova Azərbaycanda İT xidmətləri, veb dizayn, mobil tətbiq hazırlığı, SEO və robototexnika üzrə ixtisaslaşmış aparıcı texnologiya şirkətidir. Biz innovasiya və müasir texnologiyalarla bizneslərin inkişafını təmin edirik." />

                    {/* Meta Keywords */}
                    <meta name="keywords" content="ITnova haqqımızda, İT xidmətləri, veb dizayn, mobil tətbiq hazırlığı, SEO, robototexnika, texnologiya şirkəti, itnova.az, innovasiya, Azərbaycan İT şirkəti" />

                    {/* Open Graph Meta Tags (for social sharing) */}
                    <meta property="og:title" content="ITnova Haqqımızda - İT, Veb Dizayn, Mobil Tətbiq və SEO Xidmətləri" />
                    <meta property="og:description" content="ITnova İT xidmətləri, innovativ dizayn, mobil tətbiq hazırlığı və robototexnika üzrə Azərbaycanın aparıcı texnologiya şirkətidir. Biznesinizi qabaqcıl texnologiya ilə inkişaf etdirin." />
                    <meta property="og:url" content="https://itnova.az/about-us" />
                    <meta property="og:type" content="website" />
                    <meta property="og:image" content="https://itnova.az/static/media/logo.76d56b1f9b610982be1a.png" />
                </Helmet>
                {/* <header className='about_header w-full h-[50vh]'>
                    <div className='container h-full'>
                        <div className=' flex flex-col p-[120px_0] h-full'>
                            <div className='flex items-center gap-[6px]  '>
                                <Link className='text-[#676879] font-[700] text-[24px] hover:text-[var(--orange)]'>Home /</Link>

                                <Link className='text-[var(--orange)] font-[700] text-[24px]'>  About Us</Link>
                            </div>

                            <div className='mt-[32px]'>
                                <h1 className='text-[32px] font-[700] text-[#fff]'>Bizimlə Texnologiya Sərhədsizdir</h1>

                                <p className='text-[#676879] font-[600] text-[24px] max-w-[500px] mt-[20px] hover:text-[var(--orange)]'>
                                    Biz, texnologiyanın gücü ilə sərhədsiz IT həlləri təqdim edirik. Məqsədimiz, işinizi inkişaf etdirərək rəqəmsal imkanları maksimuma çatdırmaqdır.
                                </p>

                                <div className='flex  mt-[20px]'>
                                    <Link className='bg-[#0E38B1] text-[#fff] text-[18px] font-[500] p-[14px_16px] rounded-[8px] flex items-center gap-[8px]'>
                                        Xidmətlərimiz

                                        <RightSvg fill="#fff" height="22" width="22" />
                                    </Link>
                                </div>


                            </div>
                        </div>
                    </div>
                </header> */}


                <PagesHeader
                    title="Haqqımızda"
                    text="ITnova olaraq, müasir texnologiyalarla müştərilərimiz üçün effektiv və kreativ rəqəmsal həllər yaradırıq. Məqsədimiz, işinizi rəqabətcil və davamlı inkişaf etdirməkdir."
                    className="header_back"

                />

                <AboutCompanyAU />

                <VisionAU />



                <section className='bg-[#fff] p-[52px_0] '>
                    <div className='container'>
                        <div>
                            <SectionHeader title="Tez-tez verilən suallar" />
                        </div>

                        <div className='mt-[32px] flex flex-col gap-[24px]'>
                            <Faq
                                question="Web sayt hazırlanması nə qədər vaxt aparır?"
                                answer="Hər bir layihə fərqlidir, amma adətən 4-6 həftə ərzində layihəni tamamlayırıq."
                            />
                            <Faq
                                question="SEO nəticələri nə qədər müddətə görünür?"
                                answer="SEO strategiyalarımız bir neçə aya qədər təsirini göstərməyə başlayır. Amma daimi inkişaf və müşahidə vacibdir."
                            />
                            <Faq
                                question="Saytım mobil cihazlar üçün uyğun olacaqmı?"
                                answer="Bəli, hazırladığımız bütün saytlar tam responsiv olur, yəni həm mobil, həm də masaüstü cihazlar üçün uyğunlaşdırılır."
                            />
                        </div>

                    </div>
                </section>

            </main>
        )
    }
}

export default AboutUs